import yup from "@/yup";

export function useAddActionFormSchema() {
  const types = [
    "main",
    "game",
    "document",
    "contacts",
    "category",
    "sport_history",
    "sport_from_shop",
    "wallet",
    "new_games",
    "popular_games",
    "promoted_games",
  ] as const;

  return yup.object({
    type: yup
      .mixed<(typeof types)[number]>()
      .oneOf([...types])
      .required(),
    domainId: yup.number().integer().nullable().defined(),
    domainPriority: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value,
      )
      .integer()
      .min(0)
      .optional(),
    data: yup.string().nullable().defined(),
  });
}

export type AddActionFormSchema = yup.InferType<
  ReturnType<typeof useAddActionFormSchema>
>;
